export default __webpack_public_path__ + "static/media/congrats-bg.2bf444e5.gif";